import { render, staticRenderFns } from "./BannedEmployees.vue?vue&type=template&id=21851df9&scoped=true"
import script from "./BannedEmployees.vue?vue&type=script&lang=js"
export * from "./BannedEmployees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21851df9",
  null
  
)

export default component.exports